<template>
    <v-container fluid>
        <v-data-table-virtual
            :headers="headers"
            :items="filteredItems"
            hide-default-footer
            fixed-header
            calculate-widths
            :loading="loading"
            height="70vh"
            class="table"
        >
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) of headers" :key="index" class="px-4">
                        <v-row no-gutters v-if="index === 0">
                            <v-col cols="12" class="font-weight-medium">
                                {{ props.item.name }}
                            </v-col>
                            <!-- Ajouter le résumé de l'état des 411 de cette thirdPartyCompany -->
                            <!-- <v-col cols="12" style="opacity: 0.7" :class="haveFec(props.item) ? 'secondary--text' : 'error--text'">
                                {{ getPreviousFecStatus(props.item) }}
                            </v-col> -->
                        </v-row>
                        <v-row no-gutters v-else>
                            <v-col cols="12" class="font-weight-medium">
                                {{
                                    newCommonFormatCurrency(
                                        props.item.amountsPerMonth[index - 1],
                                        undefined,
                                    )
                                }}
                            </v-col>
                        </v-row>
                    </td>
                </tr>
            </template>
        </v-data-table-virtual>
    </v-container>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";

import gql from "graphql-tag";
import moment from "moment-timezone";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class OutstandingMatrice extends Vue {
    @Prop({ default: null }) companyId: any;
    @Prop({ default: [] }) clients: Array<any>;
    @Prop({ default: null }) startDate: string;
    @Prop({ default: null }) endDate: string;
    // @Prop({ default: null }) searchFromParent: string

    get loading() {
        if (this.$apollo.queries.items) {
            return this.$apollo.queries.items.loading;
        }
    }

    get headers() {
        const header: Array<any> = [
            {
                title: "Société",
                align: "start",
                sortable: false,
                value: "name",
            },
        ];
        let currentDate = this.formatMonth(this.startDate);
        do {
            header.push({
                title: currentDate,
                value: currentDate,
                sortable: false,
                width: "100px",
            });
            currentDate = this.nextDate(currentDate);
            // console.log(count++)
        } while (this.isEndIteration(currentDate));
        return header;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get filteredItems() {
        if (!this.clients) {
            return [];
        }
        // if (this.searchFromParent) {
        //     const search = this.searchFromParent.toLowerCase()
        //     const result = []
        //     for (const item of this.items) {
        //         if (item.name && item.name.toLowerCase().includes(search)) {
        //             result.push(item)
        //         }
        //     }
        //     return result
        // }
        return this.items;
    }

    @Apollo({
        query: gql`
            query Stats411Monthly(
                $companyId: ID!
                $thirdPartyCompanyIds: [ID!]
                $startDate: DateTime
                $endDate: DateTime
            ) {
                stats411Monthly(
                    data: {
                        companyId: $companyId
                        thirdPartyCompanyIds: $thirdPartyCompanyIds
                        startDate: $startDate
                        endDate: $endDate
                    }
                ) {
                    dataset
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
                thirdPartyCompanyIds: this.clients.map((c) => c.id),
                startDate: this.startDate,
                endDate: this.endDate,
            };
        },
        skip() {
            debugger;
            return !this.companyId || !this.startDate || !this.endDate || !this.clients;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.stats411Monthly && data.stats411Monthly.dataset) {
                    const result = [];
                    for (const d of data.stats411Monthly.dataset) {
                        if (!result.length) {
                            this.createNewLine(d, result);
                        } else {
                            if (result[result.length - 1].thirdPartyCompanyId === d.id) {
                                result[result.length - 1].amountsPerMonth[d.month - 1] = d.amount;
                            } else {
                                this.createNewLine(d, result);
                            }
                        }
                    }
                    this.addEmptyThirdPartyCompanies(result); // when some clients have no invoices
                    this.items = result;
                } else {
                    debugger;
                }
            }
        },
    })
    items = [];

    createNewLine(d, result) {
        const newTab = [];
        newTab.length = 12;
        newTab[d.month - 1] = d.amount;
        result.push({
            thirdPartyCompanyId: d.id,
            name: d.shortName || d.name,
            amountsPerMonth: newTab,
        });
    }

    addEmptyThirdPartyCompanies(result) {
        for (const availableCompany of this.clients) {
            if (!result.some((element) => element.thirdPartyCompanyId === availableCompany.id)) {
                const d = {
                    id: availableCompany.id,
                    name: availableCompany.name,
                    month: 1,
                    amount: null,
                };
                this.createNewLine(d, result);
            }
        }
    }

    formatMonth(date) {
        const fDate = moment(date).format("YYYY-MM");
        return fDate;
    }

    nextDate(date) {
        return moment(date, "YYYY-MM").add(1, "M").format("YYYY-MM");
    }

    isEndIteration(date) {
        return moment(date, "YYYY-MM").isSameOrBefore(
            moment(this.formatMonth(this.endDate), "YYYY-MM"),
        );
    }
}

export default toNative(OutstandingMatrice);
</script>
<style></style>
